import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SalePatternIssueDocumentQuery, SalePatternIssueDocumentQueryHandlerBase, SalePatternIssueMultiDocumentQuery, SalePatternIssueMultiDocumentQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalePatternIssueDocumentQuery)
@Wrapper(SalePatternIssueDocumentQueryHandlerBase)
export class SalePatternIssueDocumentQueryHandler {
    public constructor(
        http: Http
    ) { }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalePatternIssueMultiDocumentQuery)
@Wrapper(SalePatternIssueMultiDocumentQueryHandlerBase)
export class SalePatternIssueMultiDocumentQueryHandler {
    public constructor(
        http: Http
    ) { }
}
